<template>
    <div class="login">
        <header class="header">
            <Banner />
        </header>
        <main class="main">
            <van-form class="form" ref="formRef" v-if="isTel">
                <div class="form-item">
                    <van-field type="number" :required="true" v-model="form.tel" :rules="[
              {
                validator: ValidatorPhone,
                message: 'China Mobile Error',
              },
            ]" placeholder="China Mobile" />
                </div>
                <div class="form-item">
                    <van-field type="number" :required="true" v-model="form.code" placeholder="Send Code">
                        <template #button>
                            <van-button color="#999" size="small" v-if="isSend">{{ count }}s</van-button>
                            <van-button :style="primaryBg" size="small" v-else @click="sendCode()">Send Code</van-button>
                        </template>
                    </van-field>
                </div>
                <div class="button" :style="primaryBg" @click="onSubmit">Submit</div>

            </van-form>
            <van-form class="form" ref="formRef" v-else>
                <div class="form-item">
                    <van-field :required="true" :rules="[
              {
                validator: validateEmail,
                message: 'Email',
              },
            ]" v-model="form.email" placeholder="Email" />
                </div>
                <div class="form-item">
                    <van-field :required="true" type="number" v-model="form.code" placeholder="Send Code">
                        <template #button>
                            <van-button color="#999" size="small" v-if="isSend">{{ count }}s</van-button>
                            <van-button :style="primaryBg" size="small" v-else @click="sendEmailCode()">Send Code</van-button>
                        </template>
                    </van-field>
                </div>
                <div class="button" :style="primaryBg" @click="onSubmit">Submit</div>

            </van-form>
            <div class="change-type" v-if="isEmailReg">
                <div class="divider">
                    <span>or</span>
                </div>

                <span class="change-btn" v-if="isTel" @click="hanldeChangeRegType('email',false)">Change Email Register</span>
                <span class="change-btn" v-else @click="hanldeChangeRegType('tel',true)">Change Tel Register</span>
            </div>
        </main>
    </div>
</template>

<script>
import { getUrlCode } from '@/utils';
import Toast from 'vant/lib/toast';
import { mapGetters } from 'vuex';
import httpRequest from '@/module_visitor/api/http.js';

import Banner from '@/components/Common/banner';
export default {
    data() {
        return {
            timer: null,
            count: 60,
            isSend: false,
            form: {
                code: '',
                tel: '',
                email: '',
                type: 'tel',
            },
            isTel: true,
        };
    },
    components: { Banner },
    computed: {
        ...mapGetters(['defaultInfo']),

        isEmailReg() {
            const { config } = this.defaultInfo;
            var othersJson = JSON.parse(config.others);

            if (othersJson) {
                return othersJson.isEmailReg;
            }
            return false;
        },
        primaryBg() {
            return { background: this.defaultInfo.config.primaryColor };
        },
        primaryColor() {
            return { color: this.defaultInfo.config.primaryColor };
        },
    },

    methods: {
        back() {
            this.$router.go(-1);
        },
        // 验证手机
        ValidatorPhone(val) {
            return /^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(val);
        },
        validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        hanldeChangeRegType(type, isTel) {
            this.form.type = type;
            this.isTel = isTel;
        },
        // 验证码
        Countdown() {
            this.isSend = true;
            this.timer = setInterval(() => {
                this.count--;
                if (this.count == 0) {
                    this.timer == null;
                    this.count = 60;
                    clearInterval(this.timer);
                    this.isSend = false;
                }
            }, 1000);
        },

        // 发送验证码
        sendCode() {
            let params = {
                tel: this.form.tel,
            };
            httpRequest.post(`/api/company/sendCode`, params).then(res => {
                const { data, code, msg } = res.data;
                if (code == 200) {
                    Toast.success('Send Success');
                    this.Countdown();
                } else {
                    Toast.fail('Code Error');
                }
            });
        },
        sendEmailCode() {
            var acid = getUrlCode();
            let params = {
                email: this.form.email,
                acid: acid,
            };
            httpRequest.post(`/api/visitor/sendEmailCode`, params).then(res => {
                const { data, code, msg } = res.data;
                if (code == 200) {
                    Toast.success('Send Success');
                    this.Countdown();
                } else {
                    Toast.fail('Code Error');
                }
            });
        },
        // 验证用户
        handleLogin() {
            if (this.code == '') {
                Toast('请填写验证码(Code Error)！');
                return;
            }
            let params = {
                Tel: this.form.tel,
                Email: this.form.email,
                Code: this.form.code,
                LoginType: this.form.type,
            };
            this.$refs.formRef.validate().then(() => {
                httpRequest
                    .post(`/api/visitor/verifyCode`, params)
                    .then(res => {
                        const { data, code, msg } = res.data;
                        if (code == 200) {
                            localStorage.setItem('v_token', data.token);
                            this.$router.push({ path: '/' });
                        } else if (code == 104) {
                            if (this.form.type == 'email') {
                                this.$router.push({
                                    path: '/registerEn',
                                    query: {
                                        source: this.$route.query.source,
                                        companyId: this.$route.query.companyId,
                                        teamId: this.$route.query.teamId,
                                        tel: this.form.tel,
                                        email: this.form.email,
                                    },
                                });
                            } else {
                                this.$router.push({
                                    path: '/registerEn',
                                    query: {
                                        source: this.$route.query.source,
                                        companyId: this.$route.query.companyId,
                                        teamId: this.$route.query.teamId,
                                        tel: this.form.tel,
                                        email: this.form.email,
                                    },
                                });
                            }
                        } else {
                            Toast(msg);
                        }
                    })
                    .catch(error => {});
            });
        },

        //登录
        onSubmit() {
            this.handleLogin();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.login {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    .header {
    }

    .banner {
        width: 100%;
        text-align: center;

        img {
            width: 100%;
        }
    }

    .main {
        width: 100%;
        .van-button {
            background: var(--theme_bg_color);
            color: #fff;
        }
        .form {
            .form-item {
            }
            .button {
            }
        }
        .change-type {
            margin: 40px 10px;
            .divider {
                height: 1px;
                width: 100%;

                box-sizing: border-box;
                position: relative;
                background: #eaeaea;
                span {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    display: block;
                    text-align: center;
                    width: 60px;
                    height: 30px;
                    line-height: 30px;
                    background: #fff;
                    color: #999;
                    z-index: 9;
                }
            }
            .change-btn {
                display: block;
                color: #fff;
                background: #333;
                margin-top: 12px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                margin: 40px 10px;
                border-radius: 4px;
            }
        }
        .form {
            margin: 10px;
            border-radius: 10px;
            padding: 8px 10px;

            .form-item {
                display: flex;
                align-items: center;

                font-size: 18px;
                border: 1px solid #f8f8f8;
                background: #eee;
                margin-top: 20px;

                .form-icon {
                    padding: 0 8px;

                    img {
                        width: 24px;
                        height: 36px;
                    }
                }
            }
            .form-item {
            }

            .button {
                background: var(--theme_bg_color);
                color: #fff;
                line-height: 40px;
                text-align: center;
                height: 40px;
                margin: 20px auto 0;
                width: 100%;
                border-radius: 5px;
            }
        }
    }
}
</style>